var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83 20.133H7.827c-1.743 0-3.161-1.435-3.161-3.187V9.845c0-1.753 1.418-3.178 3.161-3.178H18.99a3.175 3.175 0 0 1 3.17 3.178v2.012h2.003a3.184 3.184 0 0 1 3.17 3.188v7.101c0 1.752-1.418 3.187-3.17 3.187H13a3.183 3.183 0 0 1-3.17-3.187v-2.013Zm0-1.845v-3.243c0-1.752 1.418-3.188 3.17-3.188h7.324V9.845a1.33 1.33 0 0 0-1.335-1.333H7.827c-.732 0-1.325.596-1.325 1.333v7.1c0 .737.593 1.343 1.325 1.343H9.83Zm1.845-3.243c0-.736.593-1.333 1.325-1.333h11.162c.733 0 1.326.597 1.326 1.333v7.101c0 .736-.593 1.333-1.326 1.333H13a1.329 1.329 0 0 1-1.325-1.333v-7.101Z",
    fill: "#102B3F"
  })));
};
export default SvgCopy;